import { numFormat, roundNum } from "../../../com/dataUtil";
// 그래프
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const OperDashboardChart = ({ item, chngState }) => {
  // 차트 옵션
  const chartConfig = {
    chart: {
      backgroundColor: "#ffffff",
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      marginTop: 0,
      spacingTop: 0,
    },
    noData: {
      style: {
        color: "#444",
      },
    },
    title: {
      text: null,
    },
    credits: {
      enabled: false,
    },
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    tooltip: {
      formatter: function () {
        if (this.point.name === "위험") {
          return (
            '<span style="color:' +
            this.color +
            '">\u25CF</span> ' +
            "<b>" +
            "  위험" +
            "<br />" +
            "응급호출 : " +
            item.dangerCallCnt +
            "회" +
            "<br/>" +
            "긴급음성 : " +
            item.dangerVoiceCnt +
            "회" +
            "<br/>" +
            "자리비움(24시간) : " +
            item.dangerOutCnt +
            "회" +
            "</b>"
          );
        } else {
          return "<b>" + '<span style="color:' + this.color + '">\u25CF</span> ' + this.point.name + " : " + numFormat(this.point.y) + "</b>";
        }
      },
    },
    legend: {
      x: 50,
      align: "top",
      layout: "vertical",
      verticalAlign: "middle",
    },
    plotOptions: {
      pie: {
        size: 120,
        allowPointSelect: true,
        // cursor: 'pointer',
        dataLabels: {
          enabled: true,
          // distance: -30,
          formatter: function () {
            if (this.y !== 0) {
              return "<span>" + this.key + "<br/>" + numFormat(this.y) + "</span>";
            }
          },
          style: {
            // color: '#ffffff',
            fontSize: "14px",
            textOutline: "1px",
            fontWeight: "500",
          },
        },
      },
    },
    colors: chngState ? ["#12e05e", "#f8ac29", "#ee2a14", "#989898", "#4169d8"] : ["#E3A048", "#ACAB28", "#28B452", "#3F8EE4"],
    series: [
      {
        name: "운영현황",
        colorByPoint: true,
        innerSize: "40%",
        showInLegend: true,
        marker: {
          symbol: "circle",
          radius: 12,
        },
        data: chngState
          ? [
              { name: "정상", y: item.normalCnt },
              { name: "경고", y: item.warnCnt },
              { name: "위험", y: item.dangerCnt },
              { name: "미작동", y: item.offCnt },
              { name: "설치예정", y: item.planCnt },
            ]
          : [
              { name: "활동", y: item.activeCnt },
              { name: "식사", y: item.eatCnt },
              { name: "수면", y: item.sleepCnt },
              { name: "자리비움", y: item.outCnt },
            ],
      },
    ],
  };

  return (
    <>
      <HighchartsReact Highcharts={Highcharts} options={chartConfig} />
    </>
  );
};

export default OperDashboardChart;
